import { injectable } from "@launchtray/tsyringe-async";
import { DiceComboAction } from "./DiceComboAction";

@injectable()
export class GiftPiggyWheelAction implements DiceComboAction {
}
